import addingAnim from './reducers'

export { setAddingAnim, addAddingAnim, removeAddingAnim, clearAddingAnim } from './actions'
export { getAddingAnim } from './selectors'

export default addingAnim
